export default "__VITE_ASSET__DkcopU88__"